import { SET_IMMUNIZATIONS, REMOVE_IMMUNIZATIONS, ADD_IMMUNIZATION } from './types'

export function setImmunizations (immunizations = []) {
  return {
    type: SET_IMMUNIZATIONS,
    payload: immunizations
  }
}

export function addImmunization (immunization) {
  return dispatch => {
    dispatch({
      type: ADD_IMMUNIZATION,
      payload: immunization
    })
  }
}

export function removeImmunizations () {
  return {
    type: REMOVE_IMMUNIZATIONS
  }
}
